import AxisSelectbox from './AxisSelectbox';

export default AxisSelectbox;
